import React from 'react'

const TeamMember = (props) => {

  let content = props.content

  //console.log("TeamMember",props);



  if(!props.content){
      console.warn('No TeamMember loaded');;
      return null
  }else{
     return (

    <div className="team-member" onClick={props.click}>
        <div className="photo" style={{backgroundImage:'url('+content.acf.photo.url+')'}}>
        </div>
        <div className="name"><h3 dangerouslySetInnerHTML={{__html:content.title.rendered}} ></h3></div>
        <div className="title" dangerouslySetInnerHTML={{__html:content.acf.title}} ></div>


    </div>
  )
  }
}

export default TeamMember



// WEBPACK FOOTER //
// ./src/modules/teampage/TeamMember.js